import { render, staticRenderFns } from "./cashiersales.vue?vue&type=template&id=213d9484&"
import script from "./cashiersales.vue?vue&type=script&lang=js&"
export * from "./cashiersales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports